<div
  cdkDrag
  class="back-to-back-table-drag resize-able back-to-back-container"
  (cdkDragStarted)="dragStart()"
  (cdkDragEnded)="dragEnd()"
  cdkDragBoundary=".exotics-main"
  [ngStyle]="{ 'top.px': windowTop, 'left.px': windowLeft }"
  appResizerVertical
  appResizerHorizontal
  minWidth="805"
  minHeight="300"
>
  <div class="menu-bar" cdkDragHandle (mousedown)="updateZIndex()">
    <div class="back-to-back-table-container-content__menu-bar__title">
      White Label P&L
    </div>
    <button class="button-close" (click)="closeGrid()"></button>
  </div>

  <div class="ag-theme-balham-dark ag-grid-container">
    <ag-grid-angular
      [groupIncludeFooter]="false"
      [groupIncludeTotalFooter]="true"
      [rowGroupPanelShow]="'always'"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [sideBar]="sideBarDef"
      [gridOptions]="gridOptions"
      class="ag-theme-alpine"
      (gridReady)="onGridReady($event)"
      (sortChanged)="gridStateChanged($event)"
      (columnResized)="gridStateChanged($event)"
      (columnVisible)="gridStateChanged($event)"
      (columnMoved)="gridStateChanged($event)"
      (columnPivotChanged)="gridStateChanged($event)"
      (columnRowGroupChanged)="gridStateChanged($event)"
      (columnValueChanged)="gridStateChanged($event)"
      (columnPinned)="gridStateChanged($event)"
      class="back-to-back-grid ag-theme-balham-dark"
    >
    </ag-grid-angular>
  </div>
  <div class="back-to-back-container__footer">
    <div class="back-to-back-container__footer__timestamp">
      {{ timestamp | date: 'medium' }}
    </div>

    <form [formGroup]="filterForm" class="filter-form">
      <input
        type="text"
        placeholder="*Start Date (YYYY-MM-DD)"
        clrInput
        formControlName="start_date"
        spellcheck="false"
        autocomplete="off"
        pattern="\d\d\d\d-\d\d-\d\d"
      />

      <input
        type="text"
        placeholder="*End Date (YYYY-MM-DD)"
        clrInput
        formControlName="end_date"
        spellcheck="false"
        autocomplete="off"
        pattern="\d\d\d\d-\d\d-\d\d"
      />

      <button
        class="ui-button ui-button__footer"
        (click)="openChart()"
        type="button"
      >
        Chart
      </button>

      <button (click)="filterData()" class="ui-button ui-button__footer">
        Update
      </button>
      <button (click)="clearFilters()" class="ui-button ui-button__footer">
        Reset
      </button>
    </form>
  </div>
</div>

<app-back-to-back-trades-chart
  *ngIf="isChartOpen"
  [rowData]="rowData"
  [startDate]="startDate"
  (chartClose)="closeChart()"
  [style.top.px]="topPosition"
  [style.left.px]="leftPosition"
>
</app-back-to-back-trades-chart>
